/**
 * Diccionario de autocorrect español RD para el composer.
 *
 * Reemplaza palabras mal escritas al presionar espacio o puntuación.
 * Solo reemplaza palabra entera (no substring).
 *
 * Para añadir una palabra:
 * 1. Añadirla al objeto DICTIONARY abajo
 * 2. Asegurar que ambas keys (lowercase Y capitalizada si aplica) están
 *
 * Categorías cubiertas:
 *  · Falta de tilde común (ej: "tambien" → "también")
 *  · Falta de ñ (ej: "cumpleanos" → "cumpleaños")
 *  · Errores de tipeo rápido en chat (ej: "ke" → "que", "x" → "por")
 *  · Saludos/despedidas comunes
 *  · Nombres de clientes y lugares frecuentes (ampliable)
 */

export const DICTIONARY = {
  // ── Tildes faltantes ──
  'tambien': 'también',
  'asi': 'así',
  'aqui': 'aquí',
  'ahi': 'ahí',
  'alli': 'allí',
  'aun': 'aún',
  'ademas': 'además',
  'despues': 'después',
  'mas': 'más',
  'mama': 'mamá',
  'papa': 'papá',
  'mio': 'mío',
  'mia': 'mía',
  'mios': 'míos',
  'mias': 'mías',
  'tio': 'tío',
  'tia': 'tía',
  'dia': 'día',
  'dias': 'días',
  'sabado': 'sábado',
  'miercoles': 'miércoles',
  'estas': 'estás',
  'esta': 'está',
  'estoy': 'estoy',
  'estaras': 'estarás',
  'estara': 'estará',
  'estare': 'estaré',
  'sera': 'será',
  'seran': 'serán',
  'fue': 'fue',
  'fui': 'fui',
  'da': 'da',
  'que': 'que',
  'quien': 'quién',
  'cuando': 'cuándo',
  'donde': 'dónde',
  'como': 'cómo',
  'cual': 'cuál',
  'cuanto': 'cuánto',
  'porque': 'porqué',
  'segun': 'según',
  'tu': 'tú',
  'el': 'él',
  'mi': 'mí',
  'si': 'sí',
  'leon': 'león',
  'corazon': 'corazón',
  'razon': 'razón',
  'cancion': 'canción',
  'oracion': 'oración',
  'situacion': 'situación',
  'condicion': 'condición',
  'reservacion': 'reservación',
  'informacion': 'información',
  'comunicacion': 'comunicación',
  'invitacion': 'invitación',
  'opcion': 'opción',
  'opciones': 'opciones',
  'eleccion': 'elección',
  'decoracion': 'decoración',
  'organizacion': 'organización',
  'realizacion': 'realización',
  'autorizacion': 'autorización',
  'facturacion': 'facturación',
  'confirmacion': 'confirmación',
  'aplicacion': 'aplicación',
  'celebracion': 'celebración',
  'celebro': 'celebró',
  'celebra': 'celebra',
  'union': 'unión',
  'comunion': 'comunión',
  'reunion': 'reunión',
  'television': 'televisión',
  'edicion': 'edición',
  'sesion': 'sesión',
  'profesion': 'profesión',
  'mision': 'misión',
  'comision': 'comisión',
  'depresion': 'depresión',
  'discusion': 'discusión',
  'decision': 'decisión',
  'extension': 'extensión',
  'pension': 'pensión',
  'tension': 'tensión',
  'expansion': 'expansión',
  'pasion': 'pasión',
  'ocasion': 'ocasión',
  'evasion': 'evasión',
  'ilusion': 'ilusión',
  'conclusion': 'conclusión',

  // ── ñ faltante ──
  'cumpleanos': 'cumpleaños',
  'cumpleano': 'cumpleaños',
  'pequeno': 'pequeño',
  'pequena': 'pequeña',
  'pequenos': 'pequeños',
  'pequenas': 'pequeñas',
  'nino': 'niño',
  'nina': 'niña',
  'ninos': 'niños',
  'ninas': 'niñas',
  'ano': 'año',
  'anos': 'años',
  'manana': 'mañana',
  'mananas': 'mañanas',
  'banar': 'bañar',
  'bano': 'baño',
  'compania': 'compañía',
  'companero': 'compañero',
  'companera': 'compañera',
  'sueno': 'sueño',
  'senor': 'señor',
  'senora': 'señora',
  'senores': 'señores',
  'senorita': 'señorita',
  'senal': 'señal',
  'senalar': 'señalar',
  'engano': 'engaño',
  'tamano': 'tamaño',
  'cariño': 'cariño',
  'cariñoso': 'cariñoso',
  'extrano': 'extraño',
  'puno': 'puño',
  'dueno': 'dueño',
  'duena': 'dueña',
  'puno': 'puño',
  'mañana': 'mañana',
  'sona': 'soña',
  'piña': 'piña',
  'caña': 'caña',
  'pana': 'paña',

  // ── Tipeo rápido / chat shortcuts ──
  'q': 'que',
  'k': 'que',
  'ke': 'que',
  'pq': 'porque',
  'xq': 'porque',
  'x': 'por',
  'd': 'de',
  'tb': 'también',
  'tmb': 'también',
  'tbn': 'también',
  'tdo': 'todo',
  'algun': 'algún',
  'ningun': 'ningún',

  // ── Saludos comunes ──
  'hla': 'Hola',
  'ola': 'Hola',
  'buenos dia': 'Buenos días',
  'buenas tarde': 'Buenas tardes',
  'buenas noche': 'Buenas noches',
  'gracias': 'gracias',
  'graciass': 'gracias',
  'graciaa': 'gracias',
  'porfa': 'por favor',
  'porfis': 'por favor',
  'pofavor': 'por favor',

  // ── Errores muy comunes ──
  'verdad': 'verdad',
  'havia': 'había',
  'habia': 'había',
  'avia': 'había',
  'haver': 'haber',
  'aver': 'haber',
  'ay': 'hay',
  'asido': 'ha sido',
  'aaa': 'ah',
  'iva': 'iba',
  'iban': 'iban',
  'voy ha': 'voy a',
  'estube': 'estuve',
  'tubo': 'tuvo',
  'tuviera': 'tuviera',
  'aiga': 'haya',
  'mismito': 'mismito',
  'echo': 'hecho',
  'hechar': 'echar',

  // ── Saludos formales (ya correctos para reforzar) ──
  'señor': 'señor',
  'señora': 'señora',
  'señorita': 'señorita',
  'estimado': 'estimado',
  'estimada': 'estimada',

  // ── Despedidas ──
  'saludos': 'saludos',
  'gracias!': 'gracias!',
  'siii': 'siii',
  'sii': 'sii',
  'jejej': 'jejej',
  'jajaj': 'jajaj',

  // ── Nombres frecuentes (ejemplos · expandir según uso) ──
  'kemely': 'Kemely',
  'kemeli': 'Kemely',
  'kemy': 'Kemely',
  'yamilex': 'Yamilex',
  'yamiles': 'Yamilex',
  'yamilez': 'Yamilex',
  'karina': 'Karina',
  'gabriela': 'Gabriela',
  'gaby': 'Gaby',
  'pamela': 'Pamela',

  // ── Lugares ──
  'romana': 'Romana',
  'santiago': 'Santiago',
  'santodomingo': 'Santo Domingo',
  'sd': 'SD',
  'sde': 'SDE',
  'sdo': 'SDO',
  'lrm': 'LRM',
  'stg': 'STG',
};

// Cache lowercase keys para lookup rápido
const LOOKUP = new Map();
for (const [bad, good] of Object.entries(DICTIONARY)) {
  LOOKUP.set(bad.toLowerCase(), good);
}

/**
 * Devuelve la corrección para una palabra, o null si no está en el diccionario.
 * Preserva capitalización: si la palabra original empieza con mayúscula, la
 * corrección también — útil para nombres propios.
 *
 * @param {string} word - palabra a verificar (sin espacios)
 * @returns {string|null} corrección o null
 */
export function getCorrection(word) {
  if (!word || word.length < 2) return null;
  const lower = word.toLowerCase();
  const correction = LOOKUP.get(lower);
  if (!correction) return null;
  if (correction === word) return null; // ya está correcto · evitar reemplazo idéntico

  // Preservar capitalización del original
  if (word === word.toUpperCase() && word.length > 1) {
    return correction.toUpperCase();
  }
  if (word[0] === word[0].toUpperCase()) {
    return correction[0].toUpperCase() + correction.slice(1);
  }
  return correction;
}

/**
 * Hook para integrar con ProseMirror: dado el texto antes de la última inserción
 * (tipicamente un espacio), revisa si la palabra previa tiene corrección.
 *
 * @param {string} textBeforeCursor - texto inmediatamente antes del cursor
 * @returns {{ word: string, correction: string, startOffset: number }|null}
 */
export function findCorrection(textBeforeCursor) {
  if (!textBeforeCursor) return null;
  // Buscar la última "palabra" — secuencia de letras (incluye á, é, ñ, etc.)
  const match = textBeforeCursor.match(/([\p{L}']+)$/u);
  if (!match) return null;
  const word = match[1];
  const correction = getCorrection(word);
  if (!correction) return null;
  return {
    word,
    correction,
    startOffset: textBeforeCursor.length - word.length,
  };
}
